import { createFileRoute } from '@tanstack/react-router'
import AllOrganizationsPage from "@/views/all-organizations-page";

export const Route = createFileRoute(
  '/_authenticated/_staff/all-organizations',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <AllOrganizationsPage/>
}
